function fillHeadersFromAspects(toRequestHeaders, logger) {
  return function (config) {
    try {
      config.headers = toRequestHeaders(config.headers);
    } catch (e) {
      logger.error('Failed enriching request', e);
    }

    return config;
  };
}

function applyResponseOnAspects(fromResponse, logger) {
  return function (response) {
    try {
      fromResponse(response.headers);
    } catch (e) {
      logger.error('Failed enriching aspects', e);
    }

    return response;
  };
}

export default function get(_ref) {
  var clientSupport = _ref.clientSupport,
      logger = _ref.logger;
  var fillHeaders = fillHeadersFromAspects(clientSupport.toRequestHeaders, logger);
  var applyOnResponse = applyResponseOnAspects(clientSupport.fromResponse, logger);
  return {
    requestSuccess: fillHeaders,
    responseSuccess: applyOnResponse
  };
}